export default {"src":"/_next/static/media/wallet_svgrepo.com.d3e90e51.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};